"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_option_button_html_1 = __importDefault(require("./global-option-button.html"));
(function (module) {
    'use strict';
    function GlbalOptionButtonController(globalOptionsModal) {
        var $ctrl = this;
        angular.extend($ctrl, {
            showGobalOptionModal: function () {
                globalOptionsModal.show();
            }
        });
    }
    GlbalOptionButtonController.$inject = ['prGlobalOptionsModal'];
    module.component('prGlobalOptionsButton', {
        templateUrl: global_option_button_html_1.default,
        controller: GlbalOptionButtonController
    });
})(angular.module('qualtrics.pr'));
